import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { getAppThemeName } from '../../services/appTheme';
const StyledPhase = styled.div `
    position: sticky;
    top: ${props => (props.type === 'next' ? '0' : 'auto')};
    bottom: ${props => (props.type === 'next' ? 'auto' : '0')};
    left: 0;
    background-color: white;
    color: ${props => props.theme.secondary};
    font-weight: 600;
    min-width: 120px;
    width: 100%;
    max-width: none;
    text-align: center;
    font-size: 15px;
    margin-top: 25px;
    margin-bottom: -30px;
    height: 24px;

    ${props => props.type === 'next' &&
    css `
            margin-top: -25px;
            margin-bottom: 30px;
        `};

    span {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        display: block;

        &:before {
            content: '';
            position: absolute;
            top: 7px;
            left: -20px;
            background-repeat: no-repeat;
            background-size: contain;
            width: 7px;
            height: 9px;

            ${props => props.appTheme === 'inkassier' &&
    css `
                    background-image: url("data:image/svg+xml,%3Csvg width='7' height='9' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3.03.265L.281 3.014a.663.663 0 000 .929.663.663 0 00.93 0l1.632-1.624v6.005c0 .366.29.657.656.657.366 0 .657-.29.657-.657V2.32L5.78 3.943a.663.663 0 001.126-.47.661.661 0 00-.197-.469L3.968.264A.668.668 0 003.5.069a.63.63 0 00-.469.197z' fill='%23FF8300' fill-rule='nonzero'/%3E%3C/svg%3E");
                `};

            ${props => props.appTheme === 'invoned' &&
    css `
                    background-image: url("data:image/svg+xml,%3Csvg width='10' height='13' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m4.324.351-3.96 3.96a.954.954 0 0 0 0 1.338.954.954 0 0 0 1.339 0L4.054 3.31v8.648a.94.94 0 0 0 .946.946.94.94 0 0 0 .946-.946V3.311l2.338 2.338a.954.954 0 0 0 1.621-.676.953.953 0 0 0-.283-.676L5.676.351A.962.962 0 0 0 5 .068c-.257 0-.5.094-.676.283Z' fill='%23FFC600' fill-rule='nonzero'/%3E%3C/svg%3E");
                `};

            ${props => props.type === 'next' &&
    css `
                    transform: rotate(180deg);
                `};
        }

        &:after {
            content: '';
            position: absolute;
            top: 7px;
            right: -20px;
            background-repeat: no-repeat;
            background-size: contain;
            width: 7px;
            height: 9px;

            ${props => props.appTheme === 'inkassier' &&
    css `
                    background-image: url("data:image/svg+xml,%3Csvg width='7' height='9' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3.03.265L.281 3.014a.663.663 0 000 .929.663.663 0 00.93 0l1.632-1.624v6.005c0 .366.29.657.656.657.366 0 .657-.29.657-.657V2.32L5.78 3.943a.663.663 0 001.126-.47.661.661 0 00-.197-.469L3.968.264A.668.668 0 003.5.069a.63.63 0 00-.469.197z' fill='%23FF8300' fill-rule='nonzero'/%3E%3C/svg%3E");
                `};

            ${props => props.appTheme === 'invoned' &&
    css `
                    background-image: url("data:image/svg+xml,%3Csvg width='10' height='13' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m4.324.351-3.96 3.96a.954.954 0 0 0 0 1.338.954.954 0 0 0 1.339 0L4.054 3.31v8.648a.94.94 0 0 0 .946.946.94.94 0 0 0 .946-.946V3.311l2.338 2.338a.954.954 0 0 0 1.621-.676.953.953 0 0 0-.283-.676L5.676.351A.962.962 0 0 0 5 .068c-.257 0-.5.094-.676.283Z' fill='%23FFC600' fill-rule='nonzero'/%3E%3C/svg%3E");
                `};

            ${props => props.type === 'next' &&
    css `
                    transform: rotate(180deg);
                `};
        }
    }
`;
const Phase = ({ type, children }) => (_jsx(StyledPhase, { type: type, appTheme: getAppThemeName(), children: _jsx("span", { children: children }) }));
export default Phase;
